<!-- Floating action button which morphs with text when scrolled to top of parent container -->
<template>
  <q-page-sticky :offset="offset">
    <q-fab
      class="morph-fab"
      padding="12px"
      direction="up"
      label-position="left"
      :color="color"
      :hide-label="!showDetails"
      :label="label"
      @click="$emit('click')"
    >
      <slot />

      <template #icon>
        <q-icon :name="icon" />
      </template>

      <template #active-icon>
        <q-icon :name="icon" />
      </template>
    </q-fab>
  </q-page-sticky>
</template>

<script>
/**
 * Override default QPageSticky with a button which can expand and contract
 *
 * SLOTS:
 * - default: content to pop up when button is clicked
 */
export default {
  props: {
    // Offset from bottom right
    offset: {
      type: Array,
      default: () => [18, 18]
    },
    // Label to show when scroll position < 20
    label: {
      type: String
    },
    // Button color
    color: {
      type: String,
      default: 'green'
    },
    // Button icon
    icon: {
      type: String,
      default: 'mdi-plus'
    },
    // Current scroll position within page
    scrollPos: {
      type: Number,
      default: 0
    }
  },
  emits: ['click'],
  computed: {
    showDetails () {
      return !!this.label && this.scrollPos < 20
    }
  }
}
</script>
